'use client';

import { Link, Text } from '@nettbureau/vibrant-ui';
import { useContext } from 'react';
import { ConfigContext } from '../provider/config-provider';
import { getTextAlignment } from '../theme';

interface CardTitleProps {
  title: string;
  href: string | null;
}

export function CardTitle({ title, href }: CardTitleProps) {
  const { cardTextAlignment } = useContext(ConfigContext);

  return href && href.length > 0 ? (
    <Text
      block
      size="2xl"
      data-featured-card-title
      align={getTextAlignment(cardTextAlignment)}
    >
      <Link aria-label="link" href={href}>
        {title}
      </Link>
    </Text>
  ) : (
    <Text
      block
      lineHeight={1.2}
      size="2xl"
      data-featured-card-title
      align={getTextAlignment(cardTextAlignment)}
    >
      {title}
    </Text>
  );
}
